// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-343d8f34] {\n    font-family: sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
